<!--
요청사항 컴포넌트
-->
<template>
    <div
        v-nl2br="request"
        :class="classObj"
        @click="checked = ! checked"
        title="click to confirm"
    >
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 요청사항
            request: String,

            // 하이라이트
            highlight: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                // (bool) 확인여부
                checked: false,
            };
        },
        computed: {
            /**
             * css 클래스명 object
             */
            classObj: function () {
                return {
                    request: true,
                    checked: this.checked,
                    highlight: this.highlight,
                };
            },
        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .request {
        text-align: center;
        padding: 1rem;

        background-color: #ffffdd;

        border: 1px solid #999;
        box-shadow: 3px 3px 3px #eee;


        color: #000;
        font-size: 1.5rem;
        //font-weight: bold;

        cursor: pointer;

        &:not(:first-child) {
            margin-top: 5px;
        }

        &.checked {
            text-decoration-line: line-through;

            background-color: #fefefe !important;
            color: #999 !important;
        }

        &.highlight {

            border: 1px solid red;
            -webkit-box-shadow: 3px 3px 3px #fffaff;
            -moz-box-shadow: 3px 3px 3px #fffaff;
            box-shadow: 3px 3px 3px #fffaff;
            color: red;
        }
    }
</style>